<div class="bg-white rounded-2xl border border-[#E7EAF0] p-6 mb-4">
    <!-- Header -->
    <div class="flex justify-between items-start">
        <div class="flex gap-3">
            <!-- Avatar -->
            <ngx-skeleton-loader appearance="circle" [theme]="{ width: '48px', height: '48px' }"></ngx-skeleton-loader>

            <div class="flex flex-col gap-[5px]">
                <!-- Name -->
                <ngx-skeleton-loader class="w-32 h-4 rounded-md"></ngx-skeleton-loader>

                <!-- Level -->
                <ngx-skeleton-loader class="w-16 h-3 rounded-md"></ngx-skeleton-loader>
            </div>
        </div>
    </div>
</div>
